<template>
  <div
    class="step_box"
    :class="{
      'stepBox-background': hasStep1,
    }"
  >
    <div
      class="step_back"
      @click.stop="toggleReturnConfirm"
      :class="{
        'single-step': stepList.length === 1,
        'step1-background': hasStep1,
      }"
    >
      <div class="list" :class="{ 'step1-return': hasStep1 }"></div>
      <div class="return_line" :class="{ 'step1-line': hasStep1 }"></div>
          <!-- 新增确认返回面板 -->
    <transition name="slide-down">
      <div v-if="showReturnConfirm" class="return-confirm-panel" @click.stop>
        <div class="triangle"></div>
        <div class="confirm-btn" @click="confirmReturn">
          确认返回列表
          <div class="returnImg"></div>
        </div>
      </div>
    </transition>
    </div>

    <!-- 点击遮罩层 -->
    <div
      v-if="showReturnConfirm"
      class="mask-layer"
      @click="hideReturnConfirm"
    ></div>

    <div class="step" :class="{ 'full-width': stepList.length === 1 }">
      <div
        v-for="(item, index) in stepList"
        :key="item.num"
        @click="jumpSteps(item)"
        class="stepBox_item"
        :style="getStepBoxStyle(index)"
        :class="[item.isBg ? `current_${item.BgNum}` : `step_${item.BgNum}`]"
      >
        <div
          v-if="item.num"
          class="step_num"
          :class="[item.isBg ? 'step_num_true' : 'step_num_false']"
        >
          {{ item.num }}
        </div>
        <div class="step_text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepList: {
      type: Array,
      required: true,
    },
    routeMap: {
      type: Object,
      required: true,
    },
    returnPath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showReturnConfirm: false,
    };
  },
  // 新增计算属性
  computed: {
    hasStep1() {
      return this.stepList.some((item) => item.BgNum === 1 && !item.isBg);
    },
  },
  methods: {
    toggleReturnConfirm() {
      this.showReturnConfirm = !this.showReturnConfirm;
    },
    hideReturnConfirm() {
      this.showReturnConfirm = false;
    },
    confirmReturn() {
      this.hideReturnConfirm();
      this.goReturn(this.returnPath);
    },
    // 动态计算 stepBox_item 的样式
    getStepBoxStyle(index) {
      const itemWidth =
        this.stepList.length === 1
          ? "100%"
          : `calc(115% / ${this.stepList.length})`;
      const leftPosition = `calc(${(100 / this.stepList.length) * index}% - ${
        1 * index
      }%)`; // 动态计算 left 值
      return `width: ${itemWidth}; left: ${leftPosition};`;
    },
    jumpSteps(item) {
      const targetPath = this.routeMap[item.num];
      if (targetPath && targetPath !== this.$route.path) {
        this.$router.push({ path: targetPath });
      }
    },
    goReturn(returnPath) {
      if (returnPath && returnPath !== this.$route.path) {
        this.$router.replace({ path: returnPath });
      }
    },
  },
};
</script>

<style scoped>
/* 新增样式 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.return-confirm-panel {
  position: absolute;
  left: 10px;
  top: 130%;
  /* transform: translateX(-50%); */
  background: white;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 9999999;
  min-width: 280px;
  text-align: center;
}
.triangle {
  position: absolute;
  top: -45%;
  width: 0px;
  height: 0px;
  border: 20px solid transparent; /*以下四个样式对应四种三角形，任选其一即可实现*/
  /* border-top-color:lightseagreen; */
  /* border-left-color:lightseagreen; */
  /* border-right-color:lightseagreen; */
  border-bottom-color: rgb(255, 255, 255);
}

.confirm-btn {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 8px 16px;
  color: #4e7ffa;
  cursor: pointer;
  font-size: 32px;
  font-family: SourceHanSansSC-Regular-2;
  font-weight: 600;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.returnImg {
  width: 36px;
  height: 36px;
  background: url("@/assets/return.png") no-repeat center;
  background-size: 100% 100%;
}
.confirm-btn:hover {
  background-color: #f0f7ff;
}

.mask-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
  background: transparent;
}
</style>
